import { ChangeEvent, useState } from "react";
import { FormikProps, useFormik } from "formik";
import { UserActivitiesPresenter } from "./UserActivitiesPresenter";
import { useGetHqActivities, useHqActivityUpdateMutation } from "./hooks";

export type EditForm = {
  activities: { name: string }[];
};

export function UserActivitiesContainer() {
  const [editing, setEditing] = useState(false);
  const { data: activities, isLoading } = useGetHqActivities();
  const { mutate } = useHqActivityUpdateMutation();

  const submitUpdates = (updates: EditForm) => {
    mutate(updates.activities.filter(a => a.name !== ''));
  };

  const formik: FormikProps<EditForm> = useFormik<EditForm>({
    initialValues: {
      activities: activities ?? []
    },
    onSubmit: submitUpdates,
    enableReinitialize: true,
  });

  const handeChange = (index: number, property: string) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      const updatedActivities = formik.values.activities;
      formik.setFieldValue('activities', updatedActivities.map((m, i) => {
        if (i === index) {
          return {
            ...m,
            [property]: event.target.value
          }
        }
        return m;
      }));
    }

  const addActivity = () => {
    const newActivities = [...formik.values.activities, { name: '' }];
    formik.setFieldValue('activities', newActivities);
  }

  const removeActivity = (index: number) => {
    const newActivities = formik.values.activities.filter((_, i) => i !== index);
    formik.setFieldValue('activities', newActivities);
  }

  return <UserActivitiesPresenter
    editing={editing}
    formik={formik}
    handeChange={handeChange}
    setEditing={setEditing}
    isLoading={isLoading}
    addActivity={addActivity}
    handleRemoveActivity={removeActivity}
  />
}
